module.exports = __webpack_public_path__ + "img/unison.d566f299.png";